module.exports = __webpack_public_path__ + "static/media/MapImage.8e13ad19.svg";